<script>
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {
  name: "Print",
  data() {
    return {
      styleObjects: [],
      printInfo: {},
      fromPage: 0,
      toPage: 0,
      showNumbers: true,
      showNotes: true,
      marketIds: [],
      magazineId: 0,
      loadedObjects: 0,
      allObjectsLoaded: false,
    }
  },
  methods: {
    print() {
      window.print();
    },
    async getPages() {

      const response = await apolloClient.query({
        query: gql`
                    query add($magazineId: Int!, $fromPage: Int!, $toPage: Int!, $marketIds: [Int!]!) {
                    getPrintInfo(magazineId: $magazineId, fromPage: $fromPage, toPage: $toPage, marketIds: $marketIds) {
                      projectName
                      magazineName
                      pages {
                        marketName
                        pageId
                        pagePosition
                      }
                    }
                  }
                `,
        variables: {
          "magazineId": this.magazineId,
          "fromPage": this.fromPage,
          "toPage": this.toPage,
          "marketIds": this.marketIds,
        },
      });

      this.printInfo = response.data.getPrintInfo;

      // sort pages by pagePosition
      this.printInfo.pages.sort((a, b) => {
        if (a.pagePosition !== b.pagePosition) {
          return a.pagePosition - b.pagePosition;
        } else {
          return parseInt(a.marketName) - parseInt(b.marketName);
        }
      });
    },
    onObjectLoad() {
      this.loadedObjects += 1;
      if (this.loadedObjects === this.printInfo.pages.length) {
        this.allObjectsLoaded = true;
      }
    },
  },
  created() {
    if (this.$isParamDefined('magazineId')) {
      this.magazineId = this.$route.params.magazineId;
    }
    if (this.$isParamDefined('startPage')) {
      this.fromPage = parseInt(this.$route.params.startPage);
    }
    if (this.$isParamDefined('endPage')) {
      this.toPage = parseInt(this.$route.params.endPage);
    }

    if (this.$isParamDefined('showNumbers')) {
      this.showNumbers = this.$route.params.showNumbers === 'true';
    }
    if (this.$isParamDefined('showNotes')) {
      this.showNotes = this.$route.params.showNotes === 'true';
    }

    if (this.$isParamDefined('marketIds')) {
      this.marketIds = this.$route.params.marketIds.split(',').map(id => parseInt(id));
    }

  },
  async mounted() {

    await this.getPages();

    this.printInfo?.pages.forEach((p, index) => {
      window.crossApi.callbacks['print' + p.pageId] = (w, h) => {
        this.styleObjects[index] = {
          width: w + 'px',
          height: h + 'px',
        };
      };
    });
  }
}
</script>

<template>
  <div class="print-background min-w-[800px]">

    <div class="flex flex-col justify-center hide-on-print bg-trader-darkest-gray text-white p-2 fixed z-[100000] w-full">
      <div v-if="!allObjectsLoaded" class="flex w-full justify-center">

        <h1 class="text-2xl">Wird geladen...</h1>
      </div>
      <div v-if="allObjectsLoaded" class="flex w-full justify-center">

        <h1 class="text-2xl">Druckvorschau</h1>
        <button class="bg-trader-green text-trader-dark-green py-1 px-2 cursor-pointer ml-2" @click="print">Jetzt drucken</button>
      </div>


    </div>

    <!--
    <div class="absolute top-[50px]">
      <img src="../assets/images/print_chrome.png" />
    </div>
    -->

    <div class="hide-on-print mt-12"></div>

    <div class="hide-on-print flex flex-col w-full items-center  p-5">
      <div class="bg-white p-5">
        <h1 class="text-2xl pb-2">Haben Sie Probleme mit dem Drucken?</h1>
        <ol>
          <li>Bitte stellen Sie folgende Eigenschaften im Druckdialog ein.</li>
          <li>1. Die Option <span class="font-bold">"Hintergrundgrafiken oder Hintergrund drucken"</span> einschalten.</li>
          <li>2. Die Option <span class="font-bold">"Ränder"</span> auf den Wert <span class="font-bold">"Keine"</span>  stellen.</li>
          <li>3. Die Option <span class="font-bold">"Skalierung oder Skalieren"</span> auf  <span class="font-bold">"Standart"</span> oder <span class="font-bold">"An Seitenbreite anpassen"</span>  stellen.</li>
          <li>4. Prüfen das keine weitere <span class="font-bold">"Skalierung"</span> aktiv ist, welche kleiner oder größer als <span class="font-bold">"100%"</span> ist.</li>
          <li>5. Die Option <span class="font-bold">"Kopf & Fußzeilen drucken"</span> ausschalten.</li>
        </ol>
      </div>
    </div>


    <div class="center">

      <div v-for="(p, i) in printInfo?.pages" class="page flex flex-col justify-center">
        <div class="flex justify-center">
          <div class="flex justify-between  w-full mx-2 my-1">
            <div>Seite: <span class="font-bold">{{ p.pagePosition }}</span></div>
            <div>Projekt: <span class="font-bold">{{ printInfo.projectName }}</span></div>
            <div>Magazin: <span class="font-bold">{{ printInfo.magazineName }}</span></div>
            <div>Markt: <span class="font-bold">{{ p.marketName }}</span></div>
          </div>
        </div>
        <div class="flex justify-center">
          <object class="w-full h-full" type="image/svg+xml" rel="pagePreview"
                  :data="'/api/v3/preview/page/' + p.pageId + '?debug=true&callback=print'+p.pageId+'&show_numbers='+ this.showNumbers+'&show_notes='+ this.showNotes+'&clickable=false&quality=3'"
                  style="display: inline-block; position: relative; overflow: hidden; height: 297mm;"
                  :style="styleObjects[i]" @load="onObjectLoad"
                  @error="onObjectLoad">
            <param name="type" value="image/svg+xml">
          </object>
        </div>
      </div>

    </div>

  </div>

</template>

<style>
@media print {
  body {
    -webkit-print-color-adjust: exact; /* Für Chromium-basierte Engines */
    print-color-adjust: exact;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>

<style scoped>



/* Stil für die Bildschirmanzeige */
.print-background {
  background: #efefef;

}

.page {
  width: 210mm; /* Breite von DIN A4 */
  padding: 20px;
  margin: 20px;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* Stil für den Druck */
@media print {
  body {
    margin: 0;
    padding: 0;
  }

  /* reset to default */
  .center {
    display: block;
    flex: none;
  }

  .print-background {
    background: none !important;
  }

  .hide-on-print {
    display: none;
  }

  .page {
    background: white;
    display: inline-block;
    box-shadow: none;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    width: 210mm; /* Breite von DIN A4 */
    min-height: 297mm; /* Höhe von DIN A4 */
    page-break-after: always; /* Umbruch nach jeder Seite */
    page-break-inside: avoid; /* Verhindert Umbrüche innerhalb einer Seite */
  }

  /* Letzte Seite ohne Seitenumbruch danach */
  .page:last-child {
    page-break-after: avoid;
  }

  /* Sicherstellen, dass Firefox Seiten korrekt bricht */
  /* Verursacht komischerweiße, dass Firefox eine leere Seite am ende beim Drucken hinzufügt
  @page {
    size: A4;
    margin: 0;
  }
  */
  /* Fix für Firefox, falls Inhalte abgeschnitten werden */
  .page {
    overflow: visible;
  }
}

</style>